import React, { useState } from 'react';
import RequestWithdraw from '../components/sections/RequestWithdraw';
import RewardTiers from '../components/sections/RewardTiers';
import PendingROI from '../components/sections/PendingROI';
import WithdrawHistory from '../components/sections/WithdrawHistory';

export default function Rewards() {
  const [refresh, setRefresh] = useState(0);
  const trigger = () => setRefresh((v) => v + 1);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title"><span className="title-accent">★</span> Rewards</h2>
          <div className="page-subtitle">Withdraw earnings & unlock tier bonuses</div>
        </div>
      </div>

      <div className="grid grid-2 mb-4" key={refresh}>
        <PendingROI onSuccess={trigger} />
        <RequestWithdraw onSuccess={trigger} />
      </div>

      <div className="mb-4">
        <WithdrawHistory refreshFlag={refresh} />
      </div>

      <RewardTiers />
    </div>
  );
}
